import { ArrowUpIcon,PlusIcon } from "@heroicons/react/24/outline";
import { _renderLoading } from "components/SectionSliderProductCard";
import WaitlistDialog from "components/WaitlistDialog";
import WaitListProductCard from "components/WaitListProductCard";
import { useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useGetMyWaitListQuery } from "store/api/productsApi";
import CommonLayout from "./CommonLayout";

const AccountSavelists = () => {
  const [showAddToWaitList, setShowAddToWaitList] = useState(false);
  const {data:waitlistProducts, isLoading: isLoadingWaitlist} = useGetMyWaitListQuery('wait-list')

  const renderSection1 = () => {
    return (
      <div className="space-y-10 sm:space-y-12">
        <div className="flex max-sm:flex-col gap-4 justify-between items-center">
          <h2 className="text-2xl sm:text-3xl font-semibold">
            Lista de espera
          </h2>
          <ButtonPrimary onClick={() => setShowAddToWaitList(true)}>
            <PlusIcon className="w-6 h-6 mr-2" />
            Agregar a la lista de espera
          </ButtonPrimary>
        </div>

        {/* Show waitlist products or empty state */}
        {isLoadingWaitlist
        ? <div className="flex justify-center items-center min-h-[200px]">
            {_renderLoading()}
          </div>
        :waitlistProducts.length > 0 ? (
          <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {waitlistProducts.map(product => (
              <WaitListProductCard
                key={product.id}
                data={product}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <svg className="w-24 h-24 max-sm:hidden mx-auto mb-4 text-gray-400" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 80 C20 80, 20 20, 80 20" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
              <path d="M80 20 L80 40" stroke="currentColor" strokeWidth="4" strokeLinecap="round" transform="rotate(120, 80, 20)"/>
              <path d="M80 20 L80 40" stroke="currentColor" strokeWidth="4" strokeLinecap="round" transform="rotate(20, 80, 20)"/>
            </svg>
            <div className="sm:hidden">
              <ArrowUpIcon className="w-16 h-16 mx-auto mb-4 text-gray-400" />
            </div>
            <p className="text-gray-500 text-lg">Tu lista de espera está vacía</p>
            <p className="text-gray-400 text-sm mt-2">
              Agrega productos a tu lista de espera para mantener un seguimiento de los artículos que te interesan
            </p>
          </div>
        )}
        
        <WaitlistDialog 
          isOpen={showAddToWaitList} 
          onClose={() => setShowAddToWaitList(false)}
        />
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderSection1()}</CommonLayout>
    </div>
  );
};

export default AccountSavelists;
